/* ZaunScout: kleine Helfer für den ganzen Shop
   - Lieferzeitraum als Datum ([data-zs-lieferdatum])
   - Zubehör im Warenkorb mit einem Klick hinzufügen ([data-zs-quick-add])
*/
(function () {
  'use strict';

  var MONATE = ['Jan.', 'Feb.', 'März', 'Apr.', 'Mai', 'Juni', 'Juli', 'Aug.', 'Sept.', 'Okt.', 'Nov.', 'Dez.'];

  // Ostersonntag (Gauß/Anonymous-Gregorian)
  function ostern(jahr) {
    var a = jahr % 19, b = Math.floor(jahr / 100), c = jahr % 100;
    var d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var monat = Math.floor((h + l - 7 * m + 114) / 31), tag = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(jahr, monat - 1, tag);
  }

  var feiertagCache = {};
  function feiertage(jahr) {
    if (feiertagCache[jahr]) return feiertagCache[jahr];
    var o = ostern(jahr);
    function plus(tage) { return new Date(o.getFullYear(), o.getMonth(), o.getDate() + tage); }
    var liste = [
      new Date(jahr, 0, 1), plus(-2), plus(1), new Date(jahr, 4, 1), plus(39), plus(50),
      new Date(jahr, 9, 3), new Date(jahr, 11, 25), new Date(jahr, 11, 26)
    ].map(function (d) { return d.toDateString(); });
    feiertagCache[jahr] = liste;
    return liste;
  }

  function istWerktag(d) {
    var tag = d.getDay();
    return tag !== 0 && tag !== 6 && feiertage(d.getFullYear()).indexOf(d.toDateString()) === -1;
  }

  function plusWerktage(start, anzahl) {
    var d = new Date(start.getFullYear(), start.getMonth(), start.getDate());
    var gezaehlt = 0;
    while (gezaehlt < anzahl) {
      d.setDate(d.getDate() + 1);
      if (istWerktag(d)) gezaehlt++;
    }
    return d;
  }

  function zeitraum(min, max) {
    var heute = new Date();
    var von = plusWerktage(heute, min);
    var bis = plusWerktage(heute, max);
    if (von.getMonth() === bis.getMonth() && von.getFullYear() === bis.getFullYear()) {
      return von.getDate() + '. bis ' + bis.getDate() + '. ' + MONATE[bis.getMonth()];
    }
    return von.getDate() + '. ' + MONATE[von.getMonth()] + ' bis ' + bis.getDate() + '. ' + MONATE[bis.getMonth()];
  }

  function lieferdaten(root) {
    (root || document).querySelectorAll('[data-zs-lieferdatum]:not([data-zs-done])').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10);
      var max = parseInt(el.getAttribute('data-max'), 10);
      if (!(min > 0) || !(max >= min)) return;
      el.textContent = 'voraussichtlich ' + zeitraum(min, max);
      el.setAttribute('data-zs-done', '');
      el.setAttribute('title', min + ' bis ' + max + ' Werktage');
    });
  }

  // „Noch X Tage“ bis zu einem echten Stichtag (z. B. Aktion auf der Startseite)
  function tageBis(root) {
    (root || document).querySelectorAll('[data-zs-tage-bis]:not([data-zs-done])').forEach(function (el) {
      var teile = String(el.getAttribute('data-zs-tage-bis')).split('-');
      if (teile.length !== 3) return;
      var ende = new Date(Number(teile[0]), Number(teile[1]) - 1, Number(teile[2]));
      var heute = new Date();
      heute = new Date(heute.getFullYear(), heute.getMonth(), heute.getDate());
      var tage = Math.round((ende - heute) / 86400000);
      el.setAttribute('data-zs-done', '');
      if (isNaN(tage) || tage < 0) { el.hidden = true; return; }
      el.textContent = tage === 0 ? 'Heute letzter Tag' : (tage === 1 ? 'Noch 1 Tag' : 'Noch ' + tage + ' Tage');
    });
  }

  window.zsShop = window.zsShop || {};
  window.zsShop.lieferzeitraum = zeitraum;
  window.zsShop.lieferdaten = lieferdaten;

  // Konfiguration teilen: am Handy das System-Menü (WhatsApp, Mail, Nachrichten …),
  // sonst ein kleines Menü am Button mit WhatsApp, E-Mail und Link kopieren
  function teilen(daten, button) {
    var titel = daten.titel || 'Meine Konfiguration bei ZaunScout';
    var text = daten.text || '';
    var url = daten.url || window.location.href;
    if (navigator.share && /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)) {
      navigator.share({ title: titel, text: text, url: url }).catch(function () {});
      return;
    }
    var offen = document.querySelector('.zs-teilen-menu');
    if (offen) {
      offen.remove();
      if (offen.zsButton === button) return;
    }
    var voll = text + '\n\n' + url;
    var menu = document.createElement('div');
    menu.className = 'zs-teilen-menu';
    menu.setAttribute('role', 'menu');
    menu.zsButton = button;
    menu.innerHTML =
      '<a role="menuitem" target="_blank" rel="noopener" data-art="whatsapp">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 20l1.2-3.6A8 8 0 1 1 8 19.1z"/><path d="M9 8.5c0 3.5 3 6.5 6.5 6.5l1-1.6-2-1-1 .9c-1-.4-2-1.4-2.4-2.4l.9-1-1-2z"/></svg>WhatsApp</a>' +
      '<a role="menuitem" data-art="mail">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="5.5" width="18" height="13" rx="2"/><path d="M3.5 7l8.5 6 8.5-6"/></svg>E-Mail</a>' +
      '<button type="button" role="menuitem" data-art="kopieren">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="8" y="8" width="12" height="12" rx="2"/><path d="M16 8V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h3"/></svg><span>Link kopieren</span></button>';
    menu.querySelector('[data-art="whatsapp"]').href = 'https://wa.me/?text=' + encodeURIComponent(voll);
    menu.querySelector('[data-art="mail"]').href = 'mailto:?subject=' + encodeURIComponent(titel) + '&body=' + encodeURIComponent(voll);
    menu.querySelector('[data-art="kopieren"]').addEventListener('click', function () {
      var label = this.querySelector('span');
      function fertig() { label.textContent = 'Link kopiert ✓'; setTimeout(function () { menu.remove(); }, 1200); }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(fertig, function () { window.prompt('Link kopieren:', url); });
      } else {
        window.prompt('Link kopieren:', url);
      }
    });
    button.insertAdjacentElement('afterend', menu);
    setTimeout(function () {
      document.addEventListener('click', function zu(event) {
        if (!menu.contains(event.target) && event.target !== button) {
          menu.remove();
          document.removeEventListener('click', zu);
        }
      });
    }, 0);
  }
  window.zsShop.teilen = teilen;

  // Zubehör direkt aus dem Warenkorb hinzufügen
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-zs-quick-add]');
    if (!button || button.disabled) return;
    event.preventDefault();
    event.stopPropagation();
    button.disabled = true;
    var text = button.textContent;
    button.textContent = 'Wird hinzugefügt …';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(button.getAttribute('data-zs-quick-add')), quantity: 1 }] })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('add');
        return response.json();
      })
      .then(function (body) {
        if (button.hasAttribute('data-zs-open-cart')) {
          // Theme öffnet den Warenkorb-Drawer
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: body } }));
        } else {
          document.dispatchEvent(new CustomEvent('cart:build'));
        }
        document.dispatchEvent(new CustomEvent('cart:updated'));
        button.textContent = 'Hinzugefügt ✓';
        window.setTimeout(function () {
          button.textContent = text;
          button.disabled = false;
        }, 2500);
      })
      .catch(function () {
        button.textContent = text;
        button.disabled = false;
      });
  });

  // Produktseite (Handy): Kaufleiste unten, solange der echte Warenkorb-Button nicht sichtbar ist
  function pdpLeiste() {
    document.querySelectorAll('[data-zs-pdp-leiste]').forEach(function (leiste) {
      var form = document.getElementById(leiste.getAttribute('data-form'));
      var original = form && (form.querySelector('button[name="add"]') || form.querySelector('[type="submit"]'));
      if (!original || !('IntersectionObserver' in window)) return;
      document.body.appendChild(leiste);
      leiste.querySelector('[data-zs-pdp-leiste-btn]').addEventListener('click', function () {
        original.click();
      });
      var preisEl = leiste.querySelector('[data-zs-pdp-leiste-preis]');
      var quelle = document.querySelector('[data-product-price]');
      function preis() {
        if (!quelle || !preisEl) return;
        var text = quelle.textContent.replace(/\s+/g, ' ').trim();
        if (text) preisEl.textContent = text;
      }
      if (quelle && 'MutationObserver' in window) new MutationObserver(preis).observe(quelle, { childList: true, subtree: true, characterData: true });
      preis();
      var sichtbar = true;
      var unterhalb = false;
      function update() {
        var zeigen = !sichtbar && unterhalb && window.innerWidth < 990 && !original.disabled;
        leiste.hidden = !zeigen;
        document.documentElement.classList.toggle('zs-pdp-leiste-an', zeigen);
      }
      new IntersectionObserver(function (e) {
        sichtbar = e[0].isIntersecting;
        unterhalb = e[0].boundingClientRect.top < 0;
        update();
      }).observe(original);
      window.addEventListener('resize', update);
    });
  }

  // Anfrageformular: Felder je nach Anliegen zeigen, Vorauswahl per ?anliegen=
  function anfrage() {
    document.querySelectorAll('[data-zs-anfrage]').forEach(function (form) {
      var wahl = form.querySelector('[data-zs-anliegen-wahl]');
      if (!wahl) return;
      var tel = form.querySelector('[data-zs-tel]');
      var pflicht = form.querySelector('[data-zs-pflicht-text]');
      function aktuell() {
        var o = wahl.options[wahl.selectedIndex];
        return o ? o.getAttribute('data-anliegen') : '';
      }
      function update() {
        var a = aktuell();
        form.querySelectorAll('[data-zs-zeigen]').forEach(function (feld) {
          var an = feld.getAttribute('data-zs-zeigen').split(' ').indexOf(a) !== -1;
          feld.hidden = !an;
          feld.querySelectorAll('input, select, textarea').forEach(function (el) { el.disabled = !an; });
        });
        if (tel) tel.required = a === 'rueckruf';
        if (pflicht) pflicht.textContent = a === 'rueckruf' ? '' : 'optional';
      }
      function waehle(wert) {
        var o = wahl.querySelector('option[data-anliegen="' + wert + '"]');
        if (o) { wahl.value = o.value; update(); }
      }
      wahl.addEventListener('change', update);
      var param = new URLSearchParams(window.location.search).get('anliegen');
      if (param) waehle(param);
      document.querySelectorAll('[data-zs-anliegen]').forEach(function (link) {
        link.addEventListener('click', function () { waehle(link.getAttribute('data-zs-anliegen')); });
      });
      update();
    });
  }

  function start() {
    pdpLeiste();
    anfrage();
    lieferdaten(document);
    tageBis(document);
    // Warenkorb-Drawer und Konfiguratoren erzeugen Inhalte nachträglich
    if ('MutationObserver' in window) {
      var geplant = false;
      new MutationObserver(function () {
        if (geplant) return;
        geplant = true;
        window.requestAnimationFrame(function () {
          geplant = false;
          lieferdaten(document);
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
